// extracted by mini-css-extract-plugin
export default {"addCard":"AddCard_addCard__M4Eig"};